export enum NewsTypes {
  OFFLINE_START = 'offline_start',
  OFFLINE_RESULTS = 'offline_results',
  ONLINE_ANNOUNCE = 'online_announce',
  ONLINE_RESULTS = 'online_results',
  MULTICUP_RESULTS = 'multicup_results',
  SIMPLE = 'text',
  DFWC_ROUND_RESULTS = 'dfwc_round_results',
  STREAMERS_RESULTS = 'streamers_results',
}
